module.exports = __webpack_public_path__ + "img/bandera_peru.1d18a5c5.svg";